import React, { Component, Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Buying by auction</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    { url: '/ways-to-purchase', name: 'Ways to purchase' },
                    {
                      url: '/ways-to-purchase/auctions',
                      name: 'Auctions',
                    },
                  ]}
                />
                <h2 className="lead text-center">Auctions</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <p>
                      Auctions require a buyer to be able to make an unconditional offer as winning an auction means
                      that, you are legally committed to purchase the property. This means getting the LIM, a builders
                      report on the home, as well as having an unconditional loan approved from a bank. This can make it
                      a pain for first home buyers as getting unconditional likely means needing to also getting the
                      home valued, which most banks require for less than 20% deposits.{' '}
                    </p>
                    <p>
                      However, unlike most purchase methods which are a bit of a gamble footing all of this upfront cost
                      when some cashed up buyer can sweep in and make all conditional offers seem unappealing, an
                      auction lets you have a direct view of what the price is going to be, and the only thing that
                      matters is the highest amount at the end. Another bonus is that the requirement for it to be
                      unconditional will wipe out a lot of competition.{' '}
                    </p>
                    <p>
                      Before the auction you’ll need to fill out a form (that the Agent will provide you) with your
                      details and any conditions (variations) that you have. If you want to change anything in the
                      agreement, or put any conditions on the sale, you need to arrange it before the auction. The
                      seller then decides whether they are happy to accept any changes or conditions you propose. It’s
                      common to update the deposit amount or the settlement times, but if you’re concerned about the
                      seller not signing off on your request, talk to the Agent selling the house.
                    </p>

                    <p>
                      If you can, attend an auction without bidding before you attend yours; ideally one being run by
                      the same auctioneer, to get a feel for how the event is run. If you can’t do that then jump on
                      Youtube and watch some auction videos. If you are super lucky you will even be able to find some
                      with the same auctioneer that will be running yours.
                    </p>
                    <p>
                      Another key consideration is to evaluate the worth of the house, and stick with your budget.
                      Auctioneers are skilled at getting every bit that they can from buyers and can be extremely
                      persuasive.{' '}
                    </p>
                    <p>
                      On the day of the auction ensure that you arrive early to get a good spot and familiarise yourself
                      with your surroundings. They best bet seems to be to stand closer to the back, and remain
                      standing. This gives you the best vantage point to watch your competition.
                    </p>
                    <p>
                      Once the auction is complete, the winning bidder will be required to make the deposit immediately,
                      so make sure you come prepared for that
                    </p>
                    <p>
                      There are many bidding strategies, so pick one that suits your personality, there are lots of
                      great videos out there explaining these, with some good examples.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ways_to_purchase/Auction.jsx